import React from "react";
import { useNavigate } from "react-router-dom";
const HeroSection = () => {
  const navigate = useNavigate();
  return (
    <section className="relative bg-gradient-to-r from-white to-blue-100 min-h-screen flex items-center">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-30"
        style={{ backgroundImage: "url('/path-to-your-background.jpg')" }}
      ></div>

      {/* Content Wrapper */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-12 text-left">
        <h1 className="text-4xl lg:text-6xl font-semibold text-gray-900">
          Your Global Partner in <span className="text-blue-600">Success</span>
        </h1>
        <p className="mt-4 text-gray-700 text-lg">
          At Talennect, a minority-owned business, our mission is to empower
          organizations across the globe to reach their goals by providing
          expert, tailoblue workforce solutions designed to meet their unique
          challenges and needs.
        </p>

        {/* Buttons */}
        <div className="mt-6 flex gap-4">
          <button
            onClick={() => navigate("/about")}
            className="bg-blue-500 text-white px-6 py-3 rounded-full text-lg shadow-md hover:bg-blue-950"
          >
            About Us
          </button>
          <button
            onClick={() => navigate("/contact")}
            className="text-gray-900 px-6 py-3 rounded-full text-lg border border-gray-300 shadow-md hover:bg-gray-100"
          >
            Contact Us →
          </button>
        </div>
      </div>

      {/* Floating Profile Elements */}
      <div className="absolute top-10 right-10 flex flex-col gap-4">
        <img
          src="https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?cs=srgb&dl=pexels-italo-melo-881954-2379004.jpg&fm=jpg"
          alt="Person 1"
          className="w-16 h-16 rounded-full shadow-lg border-4 border-white"
        />
        <img
          src="https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?cs=srgb&dl=pexels-italo-melo-881954-2379004.jpg&fm=jpg"
          alt="Person 2"
          className="w-20 h-20 rounded-full shadow-lg border-4 border-white"
        />
        <img
          src="https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?cs=srgb&dl=pexels-italo-melo-881954-2379004.jpg&fm=jpg"
          alt="Person 3"
          className="w-16 h-16 rounded-full shadow-lg border-4 border-white"
        />
      </div>
    </section>
  );
};

export default HeroSection;
